import { Alert } from '@/app/types/alertType'
import { INITIAL_SELECT_VALUE } from '@/components/ui/select/selectStyle'
import { createSlice } from '@reduxjs/toolkit'

export const InitialAlertData: Alert = {
  id: 0,
  title: '',
  product_type: [],
  size: '',
  quantity_from: 0,
  quantity_to: 0,
  comment: '',
  created_at: '',
  updated_at: '',
  product: {
    id: -1,
    name: '',
  },
  company: '',
  quantity_unit: {
    id: 0,
  },
  time_frequency: {
    id: 0,
    name: '',
  },
  origins: [],
  delivery_country: INITIAL_SELECT_VALUE,
  customTitle: '',
  needCustomTitle: false,
  activity: INITIAL_SELECT_VALUE,
  delivery_city: {
    id: 0,
    name: '',
  },
  variety: {
    varietySearchText: '',
    selectedVariety: [],
  },
  originalVarietiesList: [],
  images: [],
  croppedImage: '',
  originalCroppedImage: '',
  available_months: {
    months: [],
  },
  packaging: '',
  is_sponsored: false,
  quality: [],
  incoterms: { id: '', name: '' },
  is_confidential_alert: false,
  lng: { id: 1, label: 'English', value: 'en' },
}

export const alertFormSlice = createSlice({
  name: 'alertForm',
  initialState: InitialAlertData,
  reducers: {
    setAlert: (state, action) => {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})

export const { setAlert } = alertFormSlice.actions

export default alertFormSlice.reducer
